/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContactRole } from '../../models/contact-role';

export interface GetInventoryContactRoles$Params {
  orderType: string;
  inventoryId: string;
}

export function getInventoryContactRoles(http: HttpClient, rootUrl: string, params: GetInventoryContactRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ContactRole>>> {
  const rb = new RequestBuilder(rootUrl, getInventoryContactRoles.PATH, 'get');
  if (params) {
    rb.query('orderType', params.orderType, {});
    rb.query('inventoryId', params.inventoryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ContactRole>>;
    })
  );
}

getInventoryContactRoles.PATH = '/inventories/contact-roles';
